<div *ngIf="!(VideoUserTags.usersTag$ | async).length" class="text-align-center height-full" flex-align="center" flex-justify="center" layout="row" [ngClass]="styles.noTagsMsg">
	{{ 'Media_Videos_Pulse_NoTags' | translate }}
</div>

<ng-container *ngIf="(VideoUserTags.usersTag$ | async) as userTags">
	<div *ngIf="userTags.length" class="height-full" flex-align="center" layout="row" layout-wrap="false">
		<button type="button" [attr.aria-label]="'Carousel_Previous' | translate " [ngClass]="styles.prevButton" (click)="carousel.movePrevious()" [disabled]="carousel.isPrevButtonDisabled || userTags.length <= 5">
		</button>

		<vb-flickity-carousel #carousel flex="fill" class="height-full" [ngClass]="styles.flickityCarousel" [carouselItemModel]="userTags" [flickityConfig]="flickityConfig">
			<carousel-items>
				<in-this-video-entry-angular *ngFor="let tag of userTags" class="carousel-cell box-inline-block" [ngClass]="styles.carouselEntry" [activeUserTagId]="(VideoUserTags.activeUserTag$ | async)?.userId" [currentTimeSec]="currentTimeSec" [entryLayout]="InThisVideoEntryLayout.VERTICAL" [tag]="tag" (onToggle)="onEntryToggle($event.tag)" [tooltip]="tag.fullName" [container]="'body'" [placement]="'bottom'" pulse-carousel-entry-order [currentSlideIndex]="carousel.selectedIndex">
				</in-this-video-entry-angular>
			</carousel-items>
		</vb-flickity-carousel>

		<button type="button" [attr.aria-label]="'Carousel_Next' | translate " [ngClass]="styles.nextButton" (click)="carousel.moveNext()" [disabled]="carousel.isNextButtonDisabled || userTags.length <= 5">
		</button>
	</div>
</ng-container>